module.exports = __webpack_public_path__ + "media/images/sp/page_common/keywords/keyword_family-89ff326e425b416aa349de72410b9efe.jpg";